export const PREVIEW_QUERY_PARAMS = {
    SECRET: 'secret',
    SLUG: 'slug',
    ENTRY_ID: 'entryId',
    ENVIRONMENT: 'environment',
    CONTENT_TYPE_ID: 'contentTypeId',
};

export const DEFAULT_BLOG_CATEGORY_PAGE_SIZE = 24;

export const BLOG_CATEGORY_SEARCH_PARAMS = {
    PAGE: 'puslapis',
    PAGE_SIZE: 'puslapyje',
    SORT: 'rikiavimas',
};

export const BLOG_CATEGORY_SORT_VALUES = {
    NEWEST: 'naujausi',
    OLDEST: 'seniausi',
} as const;
